<div class="px-1">
  <app-section-header [title]="'Create new list'" [isBackBtnShown]="true">
    <div class="flex justify-end flex-1">
      <button
        mat-flat-button
        color="primary"
        (click)="createContentList()"
        class="w-1/4"
        id="create-content-list"
        [disabled]="submitted"
      >
        {{ submitted ? "Creating..." : "Create" }}
      </button>
    </div>
  </app-section-header>

  <mat-card class="p-0 mat-elevation-z0">
    <mat-card-header>
      <mat-card-title>Add list details</mat-card-title>
    </mat-card-header>
    <mat-card-content class="flex flex-wrap items-center justify-center py-3">
      <div class="basis-1/2">
        <mat-card-subtitle>Details</mat-card-subtitle>
        <form [formGroup]="contentListForm">
          <div class="flex flex-wrap gap-4">
            <div class="flex-1">
              <b class="m-0">Website:</b>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="w-full"
              >
                <mat-label>Choose a website</mat-label>
                <mat-select
                  formControlName="website"
                  (selectionChange)="resetInputNameValidation()"
                  matNativeControl
                >
                  <mat-option
                    *ngFor="let website of websiteList"
                    [value]="website.friendlyName"
                  >
                    {{ website.friendlyName }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="contentListForm.get('website').hasError('required')"
                  class="pt-1"
                >
                  Website is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex-1">
              <b class="m-0">Type: </b>
              <mat-icon
                inline
                matTooltip="{{
                  'Core list: Most common type. When creating content, this list will be available to add manually (e.g. ESG News)\nDefault list: A Core list which is added by default when creating content, but can be removed (e.g. Latest News)\nPick list: Lists designed to have no archive. Content can only be added to this list in Content List Management (e.g. Most Popular)'
                }}"
                matTooltipShowDelay="100"
                matTooltipHideDelay="5000"
                matTooltipPosition="above"
                matTooltipClass="content-type__info"
              >
                info</mat-icon
              >
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="w-full"
              >
                <mat-select formControlName="contentListType" matNativeControl>
                  <mat-option
                    *ngFor="let type of contentListTypeList"
                    [value]="type"
                    >{{ type | camelCaseSplit }}</mat-option
                  >
                </mat-select>
                <mat-error
                  *ngIf="
                    contentListForm.get('contentListType').hasError('required')
                  "
                  class="pt-1"
                >
                  Type is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <b class="m-0">Name:</b>
          <mat-form-field
            class="w-full"
            [floatLabel]="'never'"
            appearance="outline"
          >
            <input matInput placeholder="List name" formControlName="name" />
            <span
              matPrefix
              *ngIf="contentListForm.get('website').value"
              class="pr-2"
              >{{
                formatWebsitePrefix(contentListForm.get("website").value)
              }}</span
            >
            <mat-error
              *ngIf="contentListForm.get('name').hasError('required')"
              class="pt-1"
            >
              Name is required
            </mat-error>
            <mat-error
              *ngIf="
                contentListForm.get('name').hasError('contentListNameExists')
              "
              class="pt-1"
            >
              A content list with this name or code already exists. Please try a
              different name.
            </mat-error>
            <mat-error
              *ngIf="
                contentListForm.get('name').hasError('contentListNameFailure')
              "
              class="pt-1"
            >
              An error has occurred whilst trying to check the name of this
              content list. Please contact IT.
            </mat-error>
            <mat-error
              *ngIf="
                contentListForm
                  .get('name')
                  .hasError('contentListNameLengthInvalid')
              "
              class="pt-1"
            >
              Content list name needs to be longer than 3 characters and shorter
              than 50 characters.
            </mat-error>
          </mat-form-field>
          <div *ngIf="contentListForm.get('website').value">
            <b class="m-0">Content list code:</b>
            <mat-form-field
              class="w-full"
              [floatLabel]="'never'"
              appearance="outline"
              id="content-list-code"
            >
              <input
                matInput
                placeholder="Content list code"
                [value]="contentListCode"
                disabled
              />
            </mat-form-field>
          </div>
          <b class="m-0">Description:</b>
          <mat-form-field
            class="w-full"
            [floatLabel]="'never'"
            appearance="outline"
          >
            <textarea
              matInput
              formControlName="description"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              matAutosizeMaxRows="5"
              cdkAutosizeMinRows="4"
            ></textarea>
          </mat-form-field>
        </form>
      </div>
    </mat-card-content>
  </mat-card>
</div>
